module.exports = __webpack_public_path__ + "img/scholarships.69410390.jpg";